import { useAppSelector } from "@/app/appStore";
import { selectIsPlanogramSourceImageVisible } from "@/entities/annotation/model/slices/slice";
import { CanvasImage } from "@/features/sscc-visualizer/canvas-image";
import { getImageSrc } from "@/shared/api/helpers";
import { Group } from "react-konva";

interface CameraSkuSectionImageProps {
  imagePath: string | undefined;
  width: number;
  height: number;
}

const CameraSkuSectionImage = ({
  imagePath,
  width,
  height,
}: CameraSkuSectionImageProps) => {
  const isPlanogramSourceImageVisible = useAppSelector(
    selectIsPlanogramSourceImageVisible
  );

  return (
    <Group opacity={isPlanogramSourceImageVisible ? 1 : 0}>
      <CanvasImage
        src={imagePath ? getImageSrc(imagePath) : undefined}
        width={width}
        height={height}
      />
    </Group>
  );
};

export default CameraSkuSectionImage;
